import { globalHistory, Router } from '@reach/router';
import React, { lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import PrivateRoute from '../components/private-route';
import PublicRoute from '../components/public-route';

const NotFoundPage = lazy(() => import('../layouts/404'));
const LoginPage = lazy(() => import('../layouts/login'));
const UserProfilePage = lazy(() => import('../layouts/user-profile'));
const UsersPage = lazy(() => import('../layouts/users'));
const ForgotPasswordPage = lazy(() =>
  import('../components/auth/forget-password'),
);
const ProspectManagementPage = lazy(() =>
  import('../layouts/prospect-management'),
);
const ContributionDashboardPage = lazy(() =>
  import('../layouts/contribution/index'),
);

export const ROUTE_NAMES = {
  AUTH: '/login',
  HOME: '/',
  PROFILE: '/profile',
  USERS: '/users',
  FORGOTPASSWORD: '/forgot',
  PROSPECTMANAGEMENT: '/prospectmanagement',
  CONTRIBUTIONDASHBOARD: '/contribution-dashboard',
};

const PAGE_TITLES = {
  '/profile': 'MY PROFILE',
  '/users': 'USER MANAGEMENT',
  '/prospectmanagement': 'Prospect Management',
  '/': 'Prospect Management',
  '/contribution-dashboard': 'Contribution Dashboard',
};

const RouteswithoutRedux = ({ setCurrentPath }) => {
  useEffect(() => {
    globalHistory.listen(({ location }) => {
      console.log('nav action >>', location);
      const title = PAGE_TITLES[location.pathname];
      if (title) {
        setCurrentPath({
          currentPageTitle: title,
        });
      }
    });
    if (globalHistory?.location?.pathname) {
      const title = PAGE_TITLES[globalHistory.location.pathname];
      if (title) {
        setCurrentPath({
          currentPageTitle: title,
        });
      }
    }
  }, [setCurrentPath]);
  return (
    <>
      <Router>
        <PublicRoute path={ROUTE_NAMES.AUTH} component={LoginPage} />
        <PublicRoute
          path={ROUTE_NAMES.FORGOTPASSWORD}
          component={ForgotPasswordPage}
        />
        <PrivateRoute
          path={ROUTE_NAMES.HOME}
          component={ProspectManagementPage}
        />
        <PrivateRoute path={ROUTE_NAMES.USERS} component={UsersPage} />
        <PrivateRoute path="/userprofile" component={UserProfilePage} />

        <PrivateRoute
          path="/contribution-dashboard"
          component={ContributionDashboardPage}
        />

        <PrivateRoute
          path={ROUTE_NAMES.PROSPECTMANAGEMENT}
          component={ProspectManagementPage}
        />
        <NotFoundPage default />
      </Router>
    </>
  );
};

const stateMapper = (state) => ({});

const dispatchMapper = (dispatch) => ({
  setCurrentPath: dispatch.page.setCurrentPath,
});

export const Routes = connect(stateMapper, dispatchMapper)(RouteswithoutRedux);
